import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { BaseReactive302n39o7i5yop as BaseReactive } from '../../../../../reactive/com/lightningkite/reactive/core/abstracts.mjs';
import {
  _ReactiveState___get_raw__impl__92ipya3q1gard26whe6 as _ReactiveState___get_raw__impl__92ipya,
  _ReactiveState___init__impl__fvdp9b3rxdz1mjh763m as _ReactiveState___init__impl__fvdp9b,
  ReactiveStatel8ixobo86msn as ReactiveState,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
  InternalReactiveNotReady_instancer79hznuwejmn as InternalReactiveNotReady_instance,
} from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  addAndRunListener8g331b1wn43q as addAndRunListener,
  lens2x0usmj7eco4 as lens,
  lens2po2j99uxhjgr as lens_0,
  MutableReactive2qdhhyljdknhy as MutableReactive,
  Reactive1jy75v4li6ldv as Reactive,
} from '../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var WhenNullClass;
function WhenNull() {
  if (WhenNullClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'WhenNull');
    WhenNullClass = $;
  }
  return WhenNullClass;
}
var NonNullModelCacheItemClass;
function NonNullModelCacheItem() {
  if (NonNullModelCacheItemClass === VOID) {
    class $ extends BaseReactive() {
      constructor(wraps, whenNull) {
        return new.target.new_org_thecommunitygroupinc_cares_sdk_NonNullModelCacheItem_9fx7xi_k$(wraps, whenNull);
      }
      static new_org_thecommunitygroupinc_cares_sdk_NonNullModelCacheItem_9fx7xi_k$(wraps, whenNull) {
        var $this = this.new_com_lightningkite_reactive_core_BaseReactive_2kvjp3_k$();
        $this.wraps_1 = wraps;
        $this.whenNull_1 = whenNull;
        $this.release_1 = null;
        return $this;
      }
      activate_yijg9v_k$() {
        var tmp = this;
        tmp.release_1 = addAndRunListener(this.wraps_1, () => {
          // Inline function 'org.thecommunitygroupinc.cares.sdk.flatMap' call
          var this_0 = this.wraps_1.get_state_wc71uu_k$();
          var raw = _ReactiveState___get_raw__impl__92ipya(this_0);
          var tmp;
          if (equals(raw, InternalReactiveNotReady_instance)) {
            tmp = new (ReactiveState())(this_0) instanceof ReactiveState() ? this_0 : THROW_CCE();
          } else {
            if (raw instanceof InternalReactiveThrownException()) {
              tmp = new (ReactiveState())(this_0) instanceof ReactiveState() ? this_0 : THROW_CCE();
            } else {
              if (raw instanceof InternalReactiveWrapper()) {
                var tmp0_safe_receiver = raw.other_1;
                var tmp_0;
                if (tmp0_safe_receiver == null) {
                  tmp_0 = null;
                } else {
                  // Inline function 'kotlin.let' call
                  tmp_0 = _ReactiveState___init__impl__fvdp9b(tmp0_safe_receiver);
                }
                var tmp1_elvis_lhs = tmp_0;
                var tmp_1;
                var tmp_2 = tmp1_elvis_lhs;
                if ((tmp_2 == null ? null : new (ReactiveState())(tmp_2)) == null) {
                  tmp_1 = this.whenNull_1.invoke_naf6l2_k$();
                } else {
                  tmp_1 = tmp1_elvis_lhs;
                }
                tmp = tmp_1;
              } else {
                var tmp_3;
                if (raw == null) {
                  tmp_3 = null;
                } else {
                  // Inline function 'kotlin.let' call
                  tmp_3 = _ReactiveState___init__impl__fvdp9b(raw);
                }
                var tmp1_elvis_lhs_0 = tmp_3;
                var tmp_4;
                var tmp_5 = tmp1_elvis_lhs_0;
                if ((tmp_5 == null ? null : new (ReactiveState())(tmp_5)) == null) {
                  tmp_4 = this.whenNull_1.invoke_naf6l2_k$();
                } else {
                  tmp_4 = tmp1_elvis_lhs_0;
                }
                tmp = tmp_4;
              }
            }
          }
          var tmp$ret$0 = tmp;
          this.set_state_wnfcx0_k$(tmp$ret$0);
          return Unit_instance;
        });
      }
      deactivate_pmdz1g_k$() {
        var tmp0_safe_receiver = this.release_1;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver();
        this.release_1 = null;
      }
      get_lastUpdatedAt_7wjlf3_k$() {
        return this.wraps_1.get_lastUpdatedAt_7wjlf3_k$();
      }
      *set_rye9t7_k$(value, $completion) {
        return yield* this.wraps_1.set_revjhg_k$(value, $completion);
      }
      set_revjhg_k$(value, $completion) {
        return this.set_rye9t7_k$(!(value == null) ? value : THROW_CCE(), $completion);
      }
    }
    protoOf($).lens_drj4fu_k$ = lens;
    protoOf($).lens_u4wb4z_k$ = lens_0;
    initMetadataForClass($, 'NonNullModelCacheItem', VOID, VOID, [MutableReactive(), Reactive()], [1, 0]);
    NonNullModelCacheItemClass = $;
  }
  return NonNullModelCacheItemClass;
}
function notNullOrElse(_this__u8e3s4, whenNull) {
  return NonNullModelCacheItem().new_org_thecommunitygroupinc_cares_sdk_NonNullModelCacheItem_9fx7xi_k$(_this__u8e3s4, whenNull);
}
//region block: exports
export {
  WhenNull as WhenNull1z9qwiohnufo5,
  notNullOrElse as notNullOrElse323gzwh5eb92x,
};
//endregion

//# sourceMappingURL=NonNullModelCacheItem.mjs.map
